/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum FulfillmentStatus {
  FulfillmentNeeded = "Fulfillment Needed",
  FulfillmentComplete = "Fulfillment Complete",
  RescopeNeeded = "Rescope Needed",
}

export const FulfillmentStatusDisplay: Record<FulfillmentStatus, string> = {
  [FulfillmentStatus.FulfillmentNeeded]: "Fulfillment Needed",
  [FulfillmentStatus.FulfillmentComplete]: "Fulfillment Complete",
  [FulfillmentStatus.RescopeNeeded]: "Rescope Needed",
};
